import { ProxyType } from "./ProxyType";

export class ProxyConnectionParams {
    type: ProxyType = ProxyType.socks4;
    port = 0;
}
